<template>
  <div class="time-picker">
    <label
      v-if="label"
    >{{label}}</label>
    <div class="item" style="margin-left: 0;">
      <v-select
        label="Hr"
        :outlined="outlined"
        :items="hours"
        hide-details
        :value="hour"
        :disabled="disabled"
        @input="update([$event, minute, ampm])"
      />
    </div>
    <div class="item">
      <v-select
        label="Min"
        :outlined="outlined"
        :items="minutes"
        hide-details
        :value="minute"
        :disabled="disabled"
        @input="update([hour, $event, ampm])"
      />
    </div>
    <div class="item">
      <v-select
        label="am/pm"
        :outlined="outlined"
        :items="['am', 'pm']"
        hide-details
        :value="ampm"
        :disabled="disabled"
        @input="update([hour, minute, $event])"
      />
    </div>
  </div>
</template>

<style lang="scss">
.time-picker {
  text-align: left;
  label {
    text-align: left;
    display: block;
  }
  div.item {
    width: 80px;
    display: inline-block;
    margin-left: 5px;
  }
  .v-input {
    width: 80px !important;
  }
}
</style>

<script>
import range from 'lodash/range'
import padStart from 'lodash/padStart'
import toNumber from 'lodash/toNumber'
import moment from 'moment-timezone'

export default {
  props: {
    value: {
      type: String
    },
    label: {
      type: String
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    utc: {
      type: Boolean,
      default: false
    },
    allowedMinutes: {
      type: Array,
      default: null
    }
  },
  data () {
    return {}
  },
  computed: {
    hours () {
      return [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
    },
    minutes () {
      let minutes = range(0, 55, 5)
      if (this.allowedMinutes) {
        minutes = this.allowedMinutes
      }
      if ((this.minute || this.minute === 0) && !minutes.includes(this.minute)) {
        minutes.push(this.minute)
      }
      return minutes.map(m => ({ text: padStart(m + '', 2, '0'), value: m }))
    },
    hour () {
      if (!this.value) {
        return null
      }
      let hour = toNumber((this.value.split(':')[0] || 0))
      if (this.utc) {
        let m = moment().utc()
        m.hour(hour)
        m.tz(moment.tz.guess())
        hour = m.hour()
      }

      if (hour === 0) {
        return 12
      } else if (hour >= 13) {
        return hour - 12
      } else {
        return hour
      }
    },
    minute () {
      if (!this.value) {
        return null
      }
      return 1 * (this.value.split(':')[1] || 0)
    },
    ampm () {
      if (!this.value) {
        return null
      }
      let hour = toNumber((this.value.split(':')[0] || 0))
      if (this.utc) {
        let m = moment().utc()
        m.hour(hour)
        m.tz(moment.tz.guess())
        hour = m.hour()
      }
      if (hour >= 12) {
        return 'pm'
      }
      return 'am'
    }
  },
  methods: {
    update ([hour, minute, ampm]) {
      if (minute === null) {
        minute = 0
      }
      if (hour === null) {
        hour = 12
      }
      if (ampm === null) {
        ampm = 'pm'
      }
      if (ampm === 'pm' && hour !== 12) {
        hour += 12
      }
      if (ampm === 'am' && hour === 12) {
        hour = 0
      }
      if (hour === 24) {
        hour = 0
      }
      if (this.utc) {
        let m = moment()
        m.hour(hour)
        m.utc()
        hour = m.hour()
      }
      let components = [hour, minute, 0]
      components = components.map(c => padStart(c + '', 2, '0'))
      this.$emit('input', components.join(':'))
    }
  }
}
</script>
